import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminNavbar from "../components/AdminNavbar";
import { api } from "../services/api";
import "./AdminProfile.css";

export default function AdminProfile() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Admin Profile | Balitah";

    let descriptionTag = document.querySelector('meta[name="description"]');
    if (!descriptionTag) {
      descriptionTag = document.createElement("meta");
      descriptionTag.setAttribute("name", "description");
      document.head.appendChild(descriptionTag);
    }

    descriptionTag.setAttribute(
      "content",
      "Manage your administrator account on Balitah, a local Bruneian e-commerce platform.",
    );
  }, []);

  const handleLogout = async () => {
    const res = await api.logout();

    if (res.success) {
      navigate("/login");
      return;
    }

    alert(res.message || "Failed to logout");
  };

  return (
    <div className="ap-page">
      <AdminNavbar />

      <main className="ap-container">
        <section className="ap-hero">
          <div className="ap-hero-content">
            <p className="ap-kicker">Admin Account</p>
            <h1>Profile</h1>
            <p>
              You are currently signed in as an administrator. Use the action
              below to securely end this session.
            </p>
          </div>

          <div className="ap-badge" aria-hidden="true">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 3l8 4v6c0 5-3.5 7.5-8 8-4.5-.5-8-3-8-8V7l8-4z" />
              <path d="M9 12l2 2 4-4" />
            </svg>
          </div>
        </section>

        <section className="ap-panel" aria-label="Session Controls">
          <div className="ap-panel-header">
            <h2>Session</h2>
            <p>Keep your account protected by logging out when finished.</p>
          </div>

          <button
            className="ap-logout-btn"
            type="button"
            onClick={handleLogout}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            Logout
          </button>
        </section>
      </main>
    </div>
  );
}
